module.exports = __webpack_public_path__ + "img/box_pro_three_6.2731c364.jpg";